Number.prototype.format = function (n, x) {
	var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
	return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&,");
};


// WEBPACK FOOTER //
// ./src/prototype/number.js